import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
const ua = window.navigator.userAgent;
let isMobile = false;
if (ua.indexOf('iPhone') >= 0) isMobile = true;
if (ua.indexOf('Android') >= 0) isMobile = true;
if (ua.indexOf('iPad') >= 0) isMobile = true;

const path = isMobile ? '/mobile' : '';

const routes = [
  {
    path: '/',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    // component: HomeView
    component:() => import('../views'+ path +'/HomeView.vue')
    // component: () => import('../views' + path + '/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/AboutView.vue')
  },
  {
    path: '/office',
    name: 'office',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/OfficeView.vue')
  },
  {
    path: '/rentApartment',
    name: 'rentApartment',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/RentApartmentView.vue')
  },
  {
    path: '/rentApartmentJK',
    name: 'rentApartmentJK',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/RentApartmentJK.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      type: ''
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views' + path + '/login.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    meta: {
      type: 'login'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/admin.vue')
  },
  // {
  //   path: '/office',
  //   name: 'office',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/OfficeView.vue')
  // },
  {
    path: '/officeDetail',
    name: 'officeDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/officeDetail.vue')
  },
  {
    path: '/newsList',
    name: 'newsList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/newsList.vue')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/newsDetail.vue')
  },
  {
    path: '/StarsGather',
    name: 'StarsGather',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/StarsGather.vue')
  },
  {
    path: '/QingYunShe',
    name: 'QingYunShe',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/QingYunShe.vue')
  },
  {
    path: '/OurAchievement',
    name: 'OurAchievement',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/OurAchievement.vue')
  },
  {
    path: '/parkDetail',
    name: 'parkDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/parkDetail.vue')
  },
  {
    path: '/innovationvally',
    name: 'innovationvally',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/innovationvally/index.vue')
  },
  {
    path: '*',
    name: 'blankView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views'+ path +'/blankView.vue')
  },
]



const router = new VueRouter({
  mode:'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(() => {
  window.scrollTo(0,0);
})
export default router
